import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

type BadgeLabel = "short" | "medium" | "long";
type DesiredWordCountOption = 1800 | 2500 | 3500;

const badgeLabelMapping: { [key in DesiredWordCountOption]: BadgeLabel } = {
  1800: "short",
  2500: "medium",
  3500: "long",
};

export const SummaryLengthBadge = ({
  desiredWordCount,
}: {
  desiredWordCount: number;
}) => {
  const { t } = useTranslation(["home"]);
  const badgeLabel =
    badgeLabelMapping[desiredWordCount as DesiredWordCountOption];

  return (
    <div className="flex-5 text-center">
      <Badge variant="summaryLength">
        {t(`summaryLengthBadge.${badgeLabel}`)}
      </Badge>
    </div>
  );
};
